import { FC } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from '@mui/material/Autocomplete';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import { CheckboxOption } from 'common/components/CheckboxOption';
import { Dropdown } from 'common/components/dropDown/Dropdown';
import { FilterDropdownProps } from 'common/components/filter/FilterBar.types';


export const FilterDropdown: FC<FilterDropdownProps> = (props: FilterDropdownProps) => {
    const { dropdown, checkedKeys = [], onCheckboxChange, children } = props;
    const isDropdownActive = checkedKeys.keys.length > 0;

    return (
        <Dropdown
            label={dropdown.label}
            isDropdownActive={isDropdownActive}
            sx={{
                '& .dropdown_open': { color: 'primary.accent', fontWeight: 'bold' },
                '& .dropdown_closed': { color: 'secondary.dark', fontWeight: 'normal' },
            }}
        >
            {
                dropdown.isSearch && (
                    <>
                        <fieldset style={{ display: 'flex', alignItems: 'center', border: 'none', margin: '0 0 10px 0', padding: '0' }}>
                            <SearchIcon sx={{ marginRight: '7px' }}/>
                            <Autocomplete
                                freeSolo
                                disableClearable
                                options={dropdown.searchOptions}
                                sx={{ flex: '1' }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder='Search'
                                        sx={{
                                            background: 'secondary.light',
                                            padding: 0,
                                            borderRadius: '4px',
                                            '& .MuiInputBase-root fieldset': {
                                                border: 'none',
                                            },
                                            '& .MuiInputBase-root': {
                                                padding: '0',
                                            },
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            type: 'search',
                                        }}/>
                                )}/>
                        </fieldset>
                        <Divider sx={{ marginBottom: '8px' }}/>
                    </>
                )
            }
            {
                dropdown.checkBoxes.length !== 0 && (
                    <>
                        <ul style={{ listStyle: 'none', padding: '8px', marginTop: '0', marginBottom: '0' }}>
                            {dropdown.checkBoxes.map(item => (
                                <li key={item.label}>
                                    <CheckboxOption
                                        option={item}
                                        onCheckboxChange={onCheckboxChange}
                                        checked={checkedKeys.includes(item.value ?? item.label)}
                                        paginationMode={props.paginationMode}
                                    />
                                </li>
                            ))}
                        </ul>
                        <Divider sx={{ marginBottom: '8px' }}/>
                    </>
                )
            }
            {
                children
            }
            {dropdown.hasClear &&
                <button style={{ border: 'none', background: 'transparent', fontSize: '15px', fontWeight: 'bold' }}>
                    <span>
                    Clear
                    </span>
                    <CloseIcon sx={{ width: '15px', verticalAlign: 'middle' }}/>
                </button>
            }
        </Dropdown>
    );
};
